import { TenantModel } from "../../models/TenantModel";
const API_URL = `${process.env.REACT_APP_API_URL}`;
// const API_URL = process.env.REACT_APP_API_URL;

// export const GetAllTenant = async (accessToken: string): Promise<TenantModel[]> => {
//     try {
//       const url=`${API_URL}/api/OutlookAdmin/GetAllTenant`
//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//         },
//       });
      
//       console.log("Response Status:", response.status);
//       console.log("Response Body:", await response.text());
  
//       if (!response.ok) {
//         throw new Error("Failed to fetch Tenants.");
//       }
  
//       const data = await response.json();
//       console.log("Tenant Data : " , data.map(mapToTenantModel))
//       return data.map(mapToTenantModel);
//     } catch (error) {
//       throw error;
//     }
//   };

  export const GetAllTenant = async (accessToken: string, TenantId: number): Promise<TenantModel[]> => {
    try {
        const url = `${API_URL}/api/OutlookAdmin/GetAllTenant?tenantId=${TenantId}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        });

        console.log("Response Status:", response.status);

        if (!response.ok) {
            throw new Error("Failed to fetch Tenants.");
        }

        const data = await response.json();  // Read the response body only once
        console.log("Tenant Data:", data.map(mapToTenantModel));

        return data.map(mapToTenantModel);
    } catch (error) {
        throw error;
    }
};

export const mapToTenantModel = (data: any): TenantModel => {
    return {
        Id : data.id ,
        TenantID: data.tenantID || "",
        Name: data.name || "",
        Description: data.description || "",
        PhoneNumber: data.phoneNumber || "",
        Email: data.email || "",
        Address: data.address || "",
        IsActive: data.isActive || false,
        LicenseType: data.licenseType || 0,
        NoOfUsers: data.noOfUsers || 0,
        LicenseStartDate: data.licenseStartDate ? new Date(data.licenseStartDate) : new Date(),
        LicenseEndDate: data.licenseEndDate ? new Date(data.licenseEndDate) : new Date(),
        Title: data.title ||"",
        TenantLicenseID: data.tenantLicenseID ,
        LicenceTypeName:  data.licenceTypeName,
        UsedSlots: data.usedSlots || 0,
        TotalSlots: data.totalSlots|| 0,
        UnassignedSlots: data.unassignedSlots|| 0
    };
};
